<template>
   <section class="puchaseborder"></section>
</template>

<script>
export default {
  name: 'PuchaseBorder',
  componentName: 'PuchaseBorder'
}
</script>

<style lang="stylus">
.puchaseborder{
    width 100%;
    border-bottom 1px solid #E5E5E5;
    height 0px
    margin-bottom 30px
    margin-top 50px
}
</style>
